import React from "react";
import AreaReport from "./AreaReport"; // ✅ Import reusable component

const Processes = () => <AreaReport areaKey="processes" color="#457b9d" />; // ✅ Use same color as Input
export default Processes;